import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function tagComboReducer(state= initialState.tagCombo, action){
	switch(action.type){
		case types.GET_TAGS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}